(function (window, document, $) {

    $(document).ready(function () {
        // =======================================================================================================
        // Online training login 
        function token_login() {

            $('.js-token-login-form').on('submit', function (e) {

                e.preventDefault();

                var request = $.ajax({
                    url: themevars.ajaxurl,
                    data: {
                        action: 'token_login',
                        data: $('.js-token-login-form').serialize(),
                    },
                    type: 'POST',
                    beforeSend: function () {
                        $('.js-login-notification').html(
                            '<span class="fa fa-spinner"></span>'
                        );
                    }
                });

                request.done(function (result) {

                    $('.js-login-notification').html(result);

                    setTimeout(function () {

                        location.reload();

                    }, 5000);

                });
            });
        }

        token_login();


        function show_token_login() {
            if ($('[data-training-has-token-access]').length) {
                var training_id = $('[data-training-has-token-access]').data('training-has-token-access');

                $.ajax({
                    url: themevars.ajaxurl,
                    data: {
                        action: 'show_token_login',
                        id: training_id
                    },
                    type: 'POST',
                    dataType: 'json'
                }).done(function (result) {
                    if (true !== result.success || false === result.data.has_access) {
                        $('[data-training-has-token-access]').removeClass('hide');
                        return;
                    }
                });
            }
        }

        show_token_login();
    });

}(window, document, jQuery));
